import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import AuthorizeRoute from '../api-authorization/AuthorizeRoute';

import { UsersList } from './UsersList';
import { UsersAllList } from './UsersAllList';
import { UsersAdd } from './UsersAdd';
import { UsersDelete } from './UsersDelete';
import { UsersDisabled} from './UsersDisabled';
import { UsersApprove } from './UsersApprove';
import { UsersEdit } from './UsersEdit';
import { UsersPasswordChange } from './UsersPasswordChange';

export function UsersRouter() {
	let match = useRouteMatch();

	return (
		<Switch>
			<AuthorizeRoute path={`${match.path}/add`} component={UsersAdd} />
			<Route path={`${match.path}/delete/:userId`} component={UsersDelete} />
			<Route path={`${match.path}/approve/:userId`} component={UsersApprove} />
			<Route path={`${match.path}/disabled/:userId`} component={UsersDisabled} />
			<AuthorizeRoute path={`${match.path}/edit/:userId`} component={UsersEdit} />
			<AuthorizeRoute path={`${match.path}/list`} component={UsersAllList} />
			<AuthorizeRoute path={`${match.path}/password-change/:userId`} component={UsersPasswordChange} />
			<AuthorizeRoute path={`${match.path}`} component={UsersList} />
		</Switch>
	);
}